import { render } from "./SendMail.vue?vue&type=template&id=07a708e0"
import script from "./SendMail.vue?vue&type=script&lang=js"
export * from "./SendMail.vue?vue&type=script&lang=js"

import "./SendMail.vue?vue&type=style&index=0&id=07a708e0&lang=scss"

import exportComponent from "/home/airsxm/domains/airsxm.ridders.dev/public_laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__